import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'alphaNumericSort', pure: true })
export class AlphaNumericSortPipe implements PipeTransform {
  public transform<T extends Object>(list: Array<T>, field: string): Array<T> {
    const copy = [...list];

    copy.sort((a, b) => {
      const regex = /(\d+)|(\D+)/g;

      const aParts = a[field].match(regex);
      const bParts = b[field].match(regex);

      for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
        const aPart = aParts[i] || '';
        const bPart = bParts[i] || '';

        if (aPart !== bPart) {
          const aNum = parseInt(aPart, 10);
          const bNum = parseInt(bPart, 10);

          if (!isNaN(aNum) && !isNaN(bNum)) {
            return aNum - bNum;
          } else {
            return aPart.localeCompare(bPart);
          }
        }
      }

      return 0;
    });

    return copy;
  }
}
